import { render, staticRenderFns } from "./x-slider.vue?vue&type=template&id=8f57a348&scoped=true&"
import script from "./x-slider.vue?vue&type=script&lang=js&"
export * from "./x-slider.vue?vue&type=script&lang=js&"
import style0 from "./x-slider.vue?vue&type=style&index=0&id=8f57a348&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f57a348",
  null
  
)

export default component.exports